import DefaultDialogParser from "/lib/html5-software-library/src/ranj/eng/dialog/framework/serialization/DefaultDialogParser";

/**
* DialogFactory.js
* 
* Created on 3-okt-2013, 15:27:50
*
* @author Ivo Swartjes for Ranj
**/
export default class DialogFactory {
        constructor(assetLibrary, languagePack) {
            this.assetLibrary = assetLibrary;
            this.languagePack = languagePack;
            
            this.dialogCache = {};
            this.dialogParser = new DefaultDialogParser(this.languagePack);
        }

        getDialog(dialogID) {
            let dialog = this.dialogCache[dialogID];
            if (dialog) return dialog;
            
            const jsonStr = this.assetLibrary.getAsset(dialogID);
            if (! jsonStr) return null;
            
            let jsonObj;
            if (typeof jsonStr === ' string') {
                jsonObj = JSON.parse(jsonStr);               
            } else {
                 // Already parsed by PreloadJS
                jsonObj = jsonStr;
            }
            
            dialog = this.dialogParser.parseFromObject(jsonObj);
            if (! dialog) return null;
            
            this.dialogCache[dialogID] = dialog;
            
            return dialog;
        }
    }

